
export const CLOSE_SIDE_BAR = 'CLOSE_SIDE_BAR';

export interface SideBarType {
  hideNavBar: boolean;
}

const SideBarStoreState = {
  hideNavBar: false
}

const sideBar = (state = SideBarStoreState, action: any) => { /**  { type: string, payload: AnyAction } */
  switch (action.type) {
    case CLOSE_SIDE_BAR:
      return {
        ...state,
        hideNavBar: action.payload
      };
    default:
      return state;
  }
}

export default sideBar;